import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import starFlightUrl from "../../../assets/svg/star-flight.2cfcfa74.svg";
const Icons24StarFlight = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx("img", { ...props, ref, src: starFlightUrl });
});
export {
  Icons24StarFlight
};
